import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import apiService from "../backend/api";

const useProjectDetails = (projectId) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["project", projectId],
    queryFn: async () => {
      if (!projectId) return null;
      const data = await apiService.getProjectDetails(projectId);
      if (data?.error) throw new Error(data.error);
      return data;
    },
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5,
    // While a Healthcloud sync is running in the background, poll the
    // project every 5s so the badge / button reflect the final state
    // (synced / failed) without a manual reload. Polling stops as soon
    // as the status leaves "pending".
    refetchInterval: (q) => {
      const d = q?.state?.data;
      return d?.nextcloudSyncStatus === 'pending' ? 5000 : false;
    },
    refetchIntervalInBackground: false,
  });

  const deleteMutation = useMutation({
    mutationFn: async () => {
      return apiService.deleteProject(projectId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["projects"]);
    },
  });

  return {
    ...query,
    deleteProject: deleteMutation.mutate,
    isDeleting: deleteMutation.isPending,
  };
};

export default useProjectDetails;
